export default __webpack_public_path__ + "static/media/basketBall_p1.96d00ec0.jpg";